<template>
  <div>
    <div class="form-title-item">付款方相关信息</div>
    <el-form :model="formData" ref="formData">
      <el-row :gutter="24">
        <el-col :span="24" v-if="paymentSettleList.length">
          <el-form-item label-width="122px" prop="relevance">
            <span slot="label">
              <span style="color: red">*</span>关联流程：
            </span>
            <div v-for="item in paymentSettleList" :key="item.settleGuid">
              <div>
                {{ item.relevance }}
                <span
                  v-if="item.settleGuid"
                  class="file-preview"
                  @click="seeDetail(item.settleGuid)"
                  >查看详情</span
                >
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="!newServiceTenantName && oldServiceTenantName">
          <el-form-item label-width="122px">
            <span slot="label">
              <span style="color: red">*</span>付款方：
            </span>
            {{ oldServiceTenantName || "-" }}
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="newServiceTenantName && oldServiceTenantName">
          <el-form-item label-width="122px">
            <span slot="label">
              <span style="color: red">*</span>原付款方：
            </span>
            {{ oldServiceTenantName || "-" }}
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="newServiceTenantName && oldServiceTenantName">
          <el-form-item label-width="122px">
            <span slot="label">
              <span style="color: red">*</span>新付款方：
            </span>
            {{ newServiceTenantName || "-" }}
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.isChangeService == 'Y'">
          <el-form-item label-width="122px">
            <span slot="label"> 关联运营报告： </span>
            {{ formData.operationReportName || "-" }}
            <span
              v-if="formData.operationReportName"
              class="file-preview"
              @click="onViewUpstreamOperationReportDetail"
              >查看详情</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="content-main-box ml30" style="height: auto">
            <el-table
              stripe
              border
              highlight-current-row
              :data="formData.payBankInfoList"
              style="border-top: 0; border-right: 0; border-bottom: 0"
            >
              <el-table-column
                width="200px"
                prop="payBankName"
                label="付款开户银行"
              ></el-table-column>
              <el-table-column
                width="200px"
                prop="payBankAccount"
                label="付款银行账户"
              ></el-table-column>
              <el-table-column
                width="100px"
                prop="payAmount"
                label="付款金额(元)"
              >
                <template slot-scope="scope">
                  <div class="t-right">
                    {{ scope.row.payAmount | numDigit }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="100px" prop="settleDate" label="付款日期">
                <template slot-scope="scope">
                  {{ scope.row.settleDate | getDate }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "PayerInfo",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    paymentSettleList: {
      type: Array,
      default: () => [],
    },
    isLastNodePass: {
      type: Boolean,
      default: false,
    },
    isInvoicedCom: {
      type: Boolean,
      default: false,
    },
    oneCardMultipleTickets: {
      type: Boolean,
      default: false,
    },
    isMultiplePayBank: {
      type: Boolean,
      default: false,
    },
    oldServiceTenantName: {
      type: String,
      default: "",
    },
    newServiceTenantName: {
      type: String,
      default: "",
    },
    getName: {
      type: Function,
      default: () => ({}),
    },
  },
  methods: {
    seeDetail(settleGuid) {
      this.$emit("seeDetail", settleGuid);
    },
    onPreview(item) {
      this.$emit("onPreview", item);
    },
    onDownload(item) {
      this.$emit("onDownload", item);
    },
    onViewUpstreamOperationReportDetail() {
      this.$emit("onViewUpstreamOperationReportDetail");
    },
  },
};
</script>

<style lang="less" scoped>
.-ml-20 {
  margin-left: -20px;
}
/deep/ .el-row {
  margin: 0px !important;
}
.el-form-item {
  margin-bottom: 0px;
}
.over-label /deep/ .el-form-item__label {
  line-height: 21px;
}
.form-title-item {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  margin-left: 44px;
}
.form-task-title-item {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  margin-left: 44px;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  word-break: keep-all;
}
</style>
